import { render, staticRenderFns } from "./TagSuggest.vue?vue&type=template&id=38f065e2"
import script from "./TagSuggest.vue?vue&type=script&lang=js"
export * from "./TagSuggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports